export default "682d0a88dec1c1d5.svg"